import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Site, ExamType, Region } from '@model/filter/filter-options.model';

export abstract class MasterDataPort {
  abstract getSites(): Observable<Site[]>;
  abstract getExamTypes(): Observable<ExamType[]>;
  abstract getRegions(): Observable<Region[]>;
  abstract getDiagnoses(): Observable<{ id: string; name: string }[]>;
  abstract getSpecialists(): Observable<{ id: string; name: string }[]>;
  abstract getPriorities(): Observable<{ id: string; name: string }[]>;
  abstract getLaboratories(): Observable<{ id: string; name: string }[]>;
  abstract getReprocessCauses(): Observable<{ id: string; name: string }[]>;
  abstract getReprocessStatuses(): Observable<{ id: string; name: string }[]>;
  abstract getSpecimenContainers(): Observable<{ id: string; name: string }[]>;
  abstract getProviders(): Observable<{ id: string; name: string }[]>;
  abstract getInsuranceCompanies(): Observable<{ id: string; name: string }[]>;
}

export const MASTER_DATA_PORT = new InjectionToken<MasterDataPort>(
  'MasterDataPort'
);
